export const base = process.env.REACT_APP_BASE || 'api';